import type Mithril from 'mithril';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';

function translate(id: string): string {
	return app.translator.trans(id) as string;
}

export default class WelcomePage extends Page {
	oninit(vnode: Mithril.Vnode) {
		super.oninit(vnode);
		
		const user = app.session.user;
		if(user && user.exists) {
			m.route.set(app.routes['index'].path);
			return;
		}

		app.setTitle(translate('vspt_community.forum.welcome.title'));
	}

	view() {
		return <div class="WelcomePage">
			<div className="container">
				<h2>{translate('vspt_community.forum.welcome.title2')}</h2>
				<p>{translate('vspt_community.forum.welcome.text_features')}</p>
				<p>{translate('vspt_community.forum.welcome.text_social')}</p>
	
				<div class="WelcomePage-buttons">
					<Button class="Button Button--primary" onclick={() => app.modal.show(SignUpModal)}>{translate('core.forum.header.sign_up_link')}</Button>
					<Button class="Button Button--primary" onclick={() => this.continue()}>{translate('vspt_community.forum.welcome.no_sign_up')}</Button>
				</div>
				
				<p>{app.translator.trans('core.forum.sign_up.log_in_text', { a: <a onclick={() => app.modal.show(LogInModal)} /> })}</p>
			</div>
		</div>;
	}
	
	continue() {
		m.route.set(app.routes['index'].path);
	}
	
	onremove() {
		localStorage.setItem("vspt.skip-welcome", "true");
	}
}
